import request from '@/utils/request'

// 年月日プルダウン情報取得
export function getDropDowns () {
  return request({
    url: '/wareki/search',
    method: 'get'
  })
}

// 元号選択値、年選択値、月選択値取得
export async function getOptions (strYm) {
  const options = {
    gengo: '',
    year: '',
    month: ''
  }
  const yearOptions = []
  const len = strYm ? strYm.length : 0

  if (len < 4) {
    return options
  }

  const result = await getDropDowns()

  if (result.data) {
    for (const item of result.data) {
      yearOptions.unshift(item.gengoStartYear)
    }
  }

  let year = ''

  if (len === 4) {
    year = parseInt(strYm)
  } else {
    year = parseInt(strYm.substring(0, 4))
    const month = parseInt(strYm.substring(4))

    // 月
    options.month = month ? month + '' : ''
  }

  const yearLen = yearOptions.length

  for (let i = 0; i < yearLen; i++) {
    if (i === yearLen - 1) {
      if (year >= yearOptions[yearLen - 1]) {
        // 年
        options.year = year - yearOptions[yearLen - 1] + 1
        // 元号
        options.gengo = yearOptions[yearLen - 1] + ''
      }
    } else {
      if (year >= yearOptions[i] && year < yearOptions[i + 1]) {
        // 年
        options.year = year - yearOptions[i] + 1
        // 元号
        options.gengo = yearOptions[i] + ''
      }
    }
  }

  return options
}